"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const sectionTabs = document.querySelector('#tabs');
    if (!sectionTabs) {
        return null;
    }
    const navTabs = Array.from(sectionTabs.querySelectorAll('.tab'));
    const cards = Array.from(sectionTabs.querySelectorAll('.card'));
    const paginationBullets = Array.from(sectionTabs.querySelectorAll('.pagination-bullet'));
    const firstTab = sectionTabs.querySelector('.tab');
    const firstCard = sectionTabs.querySelector('.card');
    const firstBullet = sectionTabs.querySelector('.pagination-bullet');
    //show first card
    if (firstTab) {
        firstTab.classList.add('active');
    }
    if (firstCard) {
        firstCard.classList.remove('is-hidden');
    }
    if (firstBullet) {
        firstBullet.classList.add('active');
    }
    /**
     * Switches the tab
     * @param number tabId
     */
    function switchTab(tabId) {
        // tabs
        navTabs.forEach(el => {
            el.classList.remove('active');
        });
        navTabs[tabId].classList.add('active');
        // cards
        cards.forEach(card => {
            const cardNumber = card.getAttribute('data-tab-number');
            if (tabId === cardNumber) {
                card.classList.remove('is-hidden');
            }
            else {
                card.classList.add('is-hidden');
            }
        });
        // pagination
        paginationBullets.forEach(bullet => {
            const paginationNumber = bullet.getAttribute('data-tab-number');
            if (tabId === paginationNumber) {
                bullet.classList.add('active');
            }
            else {
                bullet.classList.remove('active');
            }
        });
    }
    // Add click event to tabs
    navTabs.forEach(navTab => {
        navTab.addEventListener('click', () => {
            const selectedTabNumber = navTab.getAttribute('data-tab-number');
            switchTab(selectedTabNumber);
        });
    });
    // Add click event to pagination bullets
    paginationBullets.forEach(bullet => {
        bullet.addEventListener('click', () => {
            const selectedTabNumber = bullet.getAttribute('data-tab-number');
            switchTab(selectedTabNumber);
        });
    });
});
